import { useEffect } from 'react';

import { socket } from '../libs/socket';

import { handleCommonSocketMessage } from '../features/meet/tools/socket/common.socketHandlers';

export const useSocketMessages = ({
  setIsAudioClientMute,
  setIsVideoClientMute,
  onStopScreenShare,
  onGroupConnectionRequest,
  onConnectionAllowed,
  onRaisedHandChange,
}: {
  setIsAudioClientMute: (mute: boolean) => void;
  setIsVideoClientMute: (mute: boolean) => void;
  onStopScreenShare?: () => void;
  onGroupConnectionRequest?: (data: { identity: string; displayName?: string }) => void;
  onConnectionAllowed?: (data: { for: string }) => void;
  onRaisedHandChange?: (data: { identity: string; raised: boolean }) => void;
}) => {
  useEffect(() => {
    const handler = (val: { message: { action: string; data: unknown; datetime: string } }) => {
      handleCommonSocketMessage(val.message, {
        setIsAudioClientMute,
        setIsVideoClientMute,
        onStopScreenShare,
        onGroupConnectionRequest,
        onConnectionAllowed,
        onRaisedHandChange,
      });
    };

    socket.on('message', handler);

    return () => {
      socket.off('message', handler);
    };
  }, [
    setIsAudioClientMute,
    setIsVideoClientMute,
    onStopScreenShare,
    onGroupConnectionRequest,
    onConnectionAllowed,
    onRaisedHandChange,
  ]);
};
